import UploadDragger from './uploadDragger';

export default UploadDragger;
